<style scoped>
    .m-carousel{
      padding-top: 86px;
    }
</style>
<template>
    <!--/ Intro Skew Star /-->
    <section id="home" class="intro route bg-image" style="background-image: url(images/intro-bg.webp)" v-if="(!this.filial || !this.filial_escolhida) || (this.filial && this.filial.carrossel.length == 0)">
        <div class="overlay-itro"></div>
        <div class="intro-content display-table">
        <div class="table-cell">
            <div class="container-fluid">
            <!--<p class="display-6 color-d">Hello, world!</p>-->
            <h3 class="intro-title mt-3 mb-3 text-uppercase titulo-super-safra">
                <img src="images/logo.webp" alt="Logomarca do Site" class="logomarca-super-safra mb-2" style="vertical-align: text-top;"><br />
                Grupo&nbsp;&nbsp; Super&nbsp;&nbsp; Safra
            </h3>
            <p class="intro-subtitle" style="margin-top: -25px"><span class="text-slider-items">
                Tecnologia a serviço da terra,Tecnologia a serviço do campo,Tecnologia a serviço da agricultura,Tecnologia a serviço da pecuária,Tecnologia a seu serviço!
            </span><strong class="text-slider" style="font-family:'Sarah-script'; color: #994234;"></strong></p>
            <!-- <p class="pt-3"><a class="btn btn-primary btn js-scroll px-4" href="#about" role="button">Learn More</a></p> -->
            </div>
        </div>
        </div>
    </section>
    <section id="home" class="route m-carousel" v-else-if="filial != '' && filial.carrossel.length > 0">
        <div class="container">
            <div id="carrossel_com_legendas" class="carousel slide d-none d-sm-none d-md-block" data-ride="carousel">
                <ol class="carousel-indicators">
                    <li data-target="#carrossel_com_legendas"
                        v-for="(item, key) in filial.carrossel"
                        :key="key"
                        :data-slide-to="key"
                        :class="{'active' : key==0}"
                        >
                    </li>
                </ol>
                <div class="carousel-inner">
                    <div class="carousel-item" 
                        v-for="(item, key) in filial.carrossel"
                        :key="key"
                        :class="{'active' : key==0}"
                        data-interval="7000"
                        data-pause="hover"
                    >
                        <a :href="item.link" class="text-decoration-none">
                            <img :src="bannerBgImage(item.public_path)" class="d-block w-100" :alt="item.frase">
                        </a>
                        <div class="carousel-caption d-none d-md-block">
                            <h5><a :href="item.link" class="text-decoration-none">{{ item.frase }}</a></h5>
                            <p>{{ item.texto_acompanha }}</p>
                        </div>
                    </div>
                </div>
                <a class="carousel-control-prev" href="#carrossel_com_legendas" role="button" data-slide="prev">
                    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                    <span class="sr-only">Anterior</span>
                </a>
                <a class="carousel-control-next" href="#carrossel_com_legendas" role="button" data-slide="next">
                    <span class="carousel-control-next-icon" aria-hidden="true"></span>
                    <span class="sr-only">Próximo</span>
                </a>
            </div>
            <div id="lista_de_imagens" class="d-block d-sm-block d-md-none">
                <div v-for="(item, key) in filial.carrossel" :key="key"
                    :class="{'mt-3' : key!=0}">
                    <a :href="item.link" class="text-decoration-none">
                        <img :src="bannerBgImage(item.public_path)" :alt="item.frase" class="img-fluid">
                    </a>
                </div>
            </div>
        </div>
    </section>
    <!--/ Intro Skew End /-->
</template>

<script>
    export default {
        data() {
            return {
                filial_escolhida: window.filial,
                filial: '',
                filiais: window.filiais,
                carregandoImagens: true,
            }
        },
        methods: {
            bannerBgImage(image){
                return image;
            }
        },
        mounted(){
            if(this.filial_escolhida != null && this.filial_escolhida != '' && typeof this.filial_escolhida != 'undefined'){
                this.filiais.forEach((el, i, arr) => {
                    if(el.area_url == this.filial_escolhida){
                        this.filial = el;
                    }
                })
            }
        },
    }
</script>
